import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../features/auth";
import type { IMapInfo } from "../../models/storeModels/IMapInfo";
import type { Coordinate } from "ol/coordinate";

function getInitialState(){
    const initialState: IMapInfo = {
        mousePosition: null,
        mapInfoIsShown: true,
        coordsFormat: "decimal",
        scaleFormat: "scale"
    };
    return initialState
}


export const mapInfoSlice = createSlice({
    name: "mapInfo",
    initialState: getInitialState(),
    reducers: {
        setMapInfoMousePosition(state, action: PayloadAction<Coordinate>) {
            state.mousePosition = action.payload;
        },
        setMapInfoIsShown(state, action: PayloadAction<boolean>) {
            state.mapInfoIsShown = action.payload
        },
        setMapInfoCoordsFormat(state, action: PayloadAction<any>) {
            state.coordsFormat = action.payload
        },
        setMapInfoScaleFormat(state, action: PayloadAction<any>) {
            state.scaleFormat = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState();
        });
    },
});

export const { setMapInfoMousePosition, setMapInfoIsShown, setMapInfoCoordsFormat, setMapInfoScaleFormat } = mapInfoSlice.actions;
export const mapInfoReducer = mapInfoSlice.reducer
